import React from "react";
import { Link } from "react-router-dom";
import "./index.scss";

const languages = ["spanish", "japanese", "korean"];

const Home = () => {
  return (
    <ul className="homepage">
      {languages.map((language, i) => (
        <li key={`${language}_${i}`}>
          <Link className="link" to={`/${language}`}>
            <span>{language}</span>
            <span className="dot"></span>
          </Link>
          <div className="homepage-divider" />
        </li>
      ))}
    </ul>
  );
};

export default Home;
